export default __webpack_public_path__ + "static/media/VendorManagement.88071d3b.svg";